export default __webpack_public_path__ + "static/media/otros.477be017.png";